import React from "react";
import { Button } from "../../ui/button";
import { Label } from "../../ui/label";
import { Plus, Download, Upload, Loader2, User, FileDown } from "lucide-react";

export function CedenteActions({ onDownloadTemplate, onImportCSV, onOpenDialog, isSaving, onExportCSV, isExporting }) {
  return (
    <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-semibold flex items-center gap-2">
          <User className="h-5 w-5" /> Substituídos Vinculados
        </h3>
        <div className="flex gap-2">
            <Button variant="outline" size="sm" onClick={onExportCSV} disabled={isExporting}>
                {isExporting ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <FileDown className="mr-2 h-4 w-4" />}
                Exportar
            </Button>

            <Button variant="outline" size="sm" onClick={onDownloadTemplate}>
                <Download className="mr-2 h-4 w-4" /> Baixar Modelo
            </Button>

            <input 
                type="file" 
                accept=".csv" 
                className="hidden" 
                id="csv-upload" 
                onChange={onImportCSV} 
                disabled={isSaving}
            />
            <Label htmlFor="csv-upload">
                <div className={`inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 px-3 cursor-pointer ${isSaving ? 'opacity-50 cursor-not-allowed' : ''}`}>
                    {isSaving ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Upload className="mr-2 h-4 w-4" />}
                    Importar CSV
                </div>
            </Label>

            <Button size="sm" onClick={() => onOpenDialog(true)}>
                <Plus className="mr-2 h-4 w-4" /> Adicionar Substituído
            </Button>
        </div>
    </div>
  );
}
